// Normalize identification fields for forward/backward compatibility
// (older scans used is_illinois_native / endangered_or_threatened_illinois / illinois_status_note)
export const idNative = (id) =>
  id?.is_state_native ?? id?.is_illinois_native ?? null;

export const idEndangered = (id) =>
  id?.endangered_or_threatened_in_state ?? id?.endangered_or_threatened_illinois ?? null;

export const idStateNote = (id) =>
  id?.state_status_note ?? id?.illinois_status_note ?? null;
